export const HERO_BANNER_DESKTOP_WIDTH = 2000;
export const HERO_BANNER_DESKTOP_HEIGHT = 913;

export const HERO_BANNER_MOBILE_WIDTH = 1360;
export const HERO_BANNER_MOBILE_HEIGHT = 2080;
